import React, { useEffect, useRef, useState } from "react";
import { Col, Form } from "react-bootstrap";
import ValidatedInput from "../../../../components/common/inputFields/ValidatedInput";
import {
  Box,
  FileUploaderStyled,
  LabelStyled,
  LazyImage,
  SpanStyled,
  TextStyled,
} from "../../../../components/styled/Elements";
import { useTranslation } from "react-i18next";
import {
  DateIcon,
  FileUpload,
  Plus,
  RoundedArrow,
  TrashIcon,
} from "../../../../components/styled/AllImages";
import DatePickerDefault from "../../../../components/common/inputFields/DatePicker";
import CustomRadioButton from "../../../../components/common/radioButtons/CustomRadio";
import ValidationController from "../../../../components/common/inputFields/ValidationController";
import { FormDataContainer } from "../../cabinets/files/addFile/styled";
import PhoneInputField from "../../../../components/common/inputFields/PhoneInput";
import ValidationErrorText from "../../../../components/common/inputFields/ValidationErrorText";
import { useDebounce } from "../../../../hooks/useDebounce";
import AddSingleDepartment from "../../../../components/common/modals/singleDepartmentModal/AddSingleDepartment";
import { useUser } from "../../../../context/userContext";
import { SelectedItemWrapper } from "../styled";

const UserPersonalInfo = ({
  register,
  control,
  errors,
  watch,
  resetField,
  setValue,
  location,
  locationId,
  departmentId,
  hqBranches,
  departments,
  previewImg,
  setPreviewImg,
  secondPreviewImg,
  setSecondPreviewImg,
  setInitialDepartment,
}) => {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const fileInputRefs = useRef({});

  const { user } = useUser();
  const userTypeId = Number(user?.user_type_id);
  const userType = watch("user_type_id");

  const [mapUrl, setMapUrl] = useState(
    "https://www.google.com/maps/embed/v1/place?key=AIzaSyArKfXhreAqqV5_B1w2k7Gp8CQueawp-fE&q=usa"
  );

  const deboundedLocation = useDebounce(location, 500);

  const handleFileChange = (e) => {
    const { files, name } = e.target;
    if (files[0]) {
      const objUrl = URL.createObjectURL(files[0]);
      if (name === "upload_id") {
        setPreviewImg(objUrl);
      }
      if (name === "upload_job_id") {
        setSecondPreviewImg(objUrl);
      }
    }
  };

  const handleShowMap = async (searchQuery) => {
    if (searchQuery && searchQuery.trim() !== "") {
      const encodedAddress = encodeURIComponent(searchQuery);
      const googleMapsUrl = `https://www.google.com/maps/embed/v1/place?key=AIzaSyArKfXhreAqqV5_B1w2k7Gp8CQueawp-fE&q=${encodedAddress}`;
      setMapUrl(googleMapsUrl);
    }
  };

  useEffect(() => {
    if (userTypeId !== 2 && !user?.is_temporary_admin_director) {
      setValue("user_type_id", 4);
    }
  }, []);

  useEffect(() => {
    handleShowMap(deboundedLocation);
  }, [deboundedLocation]);

  useEffect(() => {
    if (userType) resetField("licenses_allowed");
  }, [userType]);

  return (
    <FormDataContainer className="user-personal-info">
      <ValidatedInput
        name={"name"}
        type={"input"}
        fieldType={"text"}
        label="name"
        placeholder={t("namePlaceholder")}
        staric={true}
        errors={errors}
        register={register}
        validationRules={{ required: true }}
      />
      <ValidatedInput
        name={"id_number"}
        type={"input"}
        fieldType={"text"}
        label="id"
        placeholder={t("id")}
        staric={true}
        register={register}
        errors={errors}
        validationRules={{ required: true }}
      />
      <ValidatedInput
        name={"position"}
        type={"input"}
        fieldType={"text"}
        label="JobRole"
        placeholder={t("JobRole")}
        staric={true}
        register={register}
        errors={errors}
        validationRules={{ required: true }}
      />

      <Box className="w-100">
        <Box className="info-item d-flex align-items-center flex-wrap gap-3 py-4 px-3 px-lg-4">
          <Box className="form-label">
            <LabelStyled size="15px" color="var(--text)">
              {t("type")}*
            </LabelStyled>
          </Box>
          <Col>
            <Box className="d-flex flex-wrap align-items-center gap-2">
              <Col lg={3}>
                <CustomRadioButton
                  name={"user_type_id"}
                  label={t("user")}
                  value={4}
                  checked={parseInt(userType) === 4}
                  register={register}
                  validationRules={{
                    required: true,
                  }}
                />
              </Col>
              {userTypeId === 2 && (
                <Col lg={3}>
                  <CustomRadioButton
                    name={"user_type_id"}
                    label={t("admin")}
                    value={3}
                    checked={parseInt(userType) === 3}
                    register={register}
                    validationRules={{
                      required: true,
                    }}
                  />
                </Col>
              )}
            </Box>

            {errors && errors?.user_type_id?.type === "required" && (
              <ValidationErrorText text={t("Pleaseselectone")} />
            )}
          </Col>

          {parseInt(userType) === 3 && (
            <Col lg={12} className="mt-3 w-100">
              <ValidatedInput
                name={"licenses_allowed"}
                type={"input"}
                fieldType={"number"}
                placeholder={t("no_of_licenses")}
                label="no_of_licenses_allowed"
                className={"combined px-0"}
                register={register}
                errors={errors}
                validationRules={{ required: true }}
              />
            </Col>
          )}
        </Box>
      </Box>

      <Box className="info-item d-flex align-items-center formEleAddDep py-4 px-3 px-lg-4 w-100 formEleContainer">
        <Box className="form-label">
          <LabelStyled size="15px" color="var(--text)">
            {t("branch_hq")}*
          </LabelStyled>
        </Box>
        <Box>
          {userTypeId === 2 || user?.is_temporary_admin_director ? (
            <ValidationController
              name={"location_id"}
              control={control}
              validationConfig={{ required: true }}
              errors={errors}
              renderer={({ field }) => (
                <AddSingleDepartment
                  title={t("select_branch_hq")}
                  icon={<Plus />}
                  selPlaceholder={t("select_branch_hq")}
                  mainParents={hqBranches}
                  selectedItem={locationId}
                  setSelectedItem={(id) => field.onChange(id)}
                />
              )}
            />
          ) : locationId ? (
            hqBranches.length > 0 &&
            hqBranches
              .filter((hqbranch) => hqbranch.id == locationId)
              .map((hqbranch) => (
                <SelectedItemWrapper>
                  <Box className="abtUser">
                    <TextStyled>
                      <SpanStyled color="var(--text)" size="14px">
                        {hqbranch?.name}
                      </SpanStyled>
                    </TextStyled>
                    <SpanStyled color="var(--text2)" size="14px">
                      {hqbranch?.subLabel}
                    </SpanStyled>
                  </Box>
                </SelectedItemWrapper>
              ))
          ) : (
            hqBranches.length > 0 &&
            hqBranches
              .filter((hqbranch) => hqbranch.id == user?.office_location?.id)
              .map((hqbranch) => {
                setValue("location_id", hqbranch.id);
                return (
                  <SelectedItemWrapper>
                    <Box className="abtUser">
                      <TextStyled>
                        <SpanStyled color="var(--text)" size="14px">
                          {hqbranch?.name}
                        </SpanStyled>
                      </TextStyled>
                      <SpanStyled color="var(--text2)" size="14px">
                        {hqbranch?.subLabel}
                      </SpanStyled>
                    </Box>
                  </SelectedItemWrapper>
                );
              })
          )}
        </Box>
      </Box>
      <Box className="info-item d-flex align-items-center formEleAddDep py-4 px-3 px-lg-4 w-100 formEleContainer">
        <Box className="form-label">
          <LabelStyled size="15px" color="var(--text)">
            {t("department")}{`${Number(userType) !== 3 ? "*" : ""}`}
          </LabelStyled>
        </Box>
        <Box>
          <ValidationController
            name={"department_id"}
            control={control}
            validationConfig={{ required: Number(userType) !== 3 }}
            errors={errors}
            renderer={({ field }) => (
              <AddSingleDepartment
                title={t("select_department")}
                icon={<Plus />}
                selPlaceholder={t("select_department")}
                mainParents={departments}
                selectedItem={departmentId}
                setSelectedItem={(id) => {
                  if (setInitialDepartment) setInitialDepartment(false);
                  field.onChange(id);
                }}
              />
            )}
          />
          {/* {userTypeId === 2 || user?.is_temporary_admin_director ? (
            <ValidationController
              name={"department_id"}
              control={control}
              validationConfig={{ required: true }}
              errors={errors}
              renderer={({ field }) => (
                <AddSingleDepartment
                  title={t("select_department")}
                  icon={<Plus />}
                  selPlaceholder={t("select_department")}
                  mainParents={departments}
                  selectedItem={departmentId}
                  setSelectedItem={(id) => {
                    if (setInitialDepartment) setInitialDepartment(false);
                    field.onChange(id);
                  }}
                />
              )}
            />
          ) : departmentId ? (
            departments.length > 0 &&
            departments
              .filter((department) => department.id == departmentId)
              .map((department) => (
                <SelectedItemWrapper>
                  <Box className="abtUser">
                    <TextStyled>
                      <SpanStyled color="var(--text)" size="14px">
                        {department?.name}
                      </SpanStyled>
                    </TextStyled>
                    <SpanStyled color="var(--text2)" size="14px">
                      {department?.subLabel}
                    </SpanStyled>
                  </Box>
                </SelectedItemWrapper>
              ))
          ) : (
            departments.length > 0 &&
            departments
              .filter((department) => department.id == user?.department?.id)
              .map((department) => {
                setValue("department_id", departmentId);
                return (
                  <SelectedItemWrapper>
                    <Box className="abtUser">
                      <TextStyled>
                        <SpanStyled color="var(--text)" size="14px">
                          {department?.name}
                        </SpanStyled>
                      </TextStyled>
                      <SpanStyled color="var(--text2)" size="14px">
                        {department?.subLabel}
                      </SpanStyled>
                    </Box>
                  </SelectedItemWrapper>
                );
              })
          )} */}
        </Box>
      </Box>
      <ValidatedInput
        name={"location"}
        type={"input"}
        fieldType={"text"}
        label="location"
        placeholder={t("location")}
        className="combined pt-3"
        // staric={true}
        register={register}
        errors={errors}
        validationRules={{ required: false }}
      />
      {mapUrl && (
        <Box className="w-100">
          <Box className="info-item d-flex align-items-center py-4 w-100">
            <Col lg={12} className="col-12">
              <Box className="location-map-cont mx-3 my-3 mx-lg-4">
                <iframe
                  src={mapUrl}
                  style={{ border: "0" }}
                  allowfullscreen=""
                  referrerpolicy="no-referrer-when-downgrade"
                  className="location-map"
                ></iframe>
              </Box>
            </Col>
          </Box>
        </Box>
      )}
      <ValidatedInput
        name={"email"}
        type={"input"}
        fieldType={"email"}
        placeholder={t("emailPlaceholder")}
        label={t("email")}
        staric={true}
        register={register}
        errors={errors}
        validationRules={{ required: true }}
      />
      <PhoneInputField
        name="phone"
        label={"contact_no"}
        staric={true}
        placeholder={"phonePlaceholder"}
        register={register}
        control={control}
        errors={errors}
        validationRules={{
          required: true,
        }}
      />

      <Box className="info-item gap-2 d-flex align-items-center py-4 px-4 px-lg-4 w-100 formEleContainer">
        <LabelStyled size="15px" color="var(--text)">
          {t("date_of_birth")}*
        </LabelStyled>
        <Box className="w-100">
          <DatePickerDefault
            name={"date_of_birth"}
            type={"input"}
            placeholder={t("date")}
            icon={DateIcon}
            control={control}
            errors={errors}
            rules={{ required: true }}
            yearDropdown={true}
            monthDropdown={true}
            maxDate={new Date()}
            bg="var(--bgSecondary)"
          />
        </Box>
      </Box>
      <ValidatedInput
        name={"password"}
        type={"input"}
        fieldType={"password"}
        placeholder={t("passwordPlaceholder")}
        label={t("password")}
        staric={true}
        register={register}
        errors={errors}
        validationRules={{ required: true }}
      />
      <ValidatedInput
        name={"confirm_password"}
        type={"input"}
        fieldType={"password"}
        placeholder={t("confirmPasswordPlaceholder")}
        label={t("confirm_password")}
        staric={true}
        register={register}
        errors={errors}
        validationRules={{
          required: true,
          inline: true,
          validate: (value) =>
            value === watch("password") || "password_do_not_match",
        }}
      />

      <Box className="w-100">
        <Box className="info-item d-flex flex-wrap align-items-center gap-3 py-4 px-3 px-lg-4">
          <Box className="form-label">
            <LabelStyled size="15px" color="var(--text)">
              {t("upload")}
            </LabelStyled>
          </Box>
          <Col>
            <Box className="d-flex flex-wrap  gap-2">
              <Col lg={4}>
                <ValidationController
                  name={"upload_id"}
                  validationConfig={{
                    required: false,
                  }}
                  errors={errors}
                  control={control}
                  renderer={({ field }) => (
                    <FileUploaderStyled className="d-flex align-items-center justify-content-center w-100">
                      <Form
                        as="input"
                        name="upload_id"
                        type="file"
                        accept="image/*"
                        ref={(el) => (fileInputRefs.current["uploadId"] = el)}
                        onChange={(e) => {
                          handleFileChange(e);
                          field.onChange(e.target.files[0]);
                        }}
                        className="d-none"
                      />
                      {previewImg ? (
                        <Box
                          className="d-flex align-items-center justify-content-between w-100 mt-n4 preview-box"
                          onClick={(e) => {
                            if (previewImg) {
                              e.stopPropagation();
                              e.preventDefault();
                            }
                          }}
                        >
                          <div className="job-upload-preview-img">
                            <LazyImage src={previewImg} className="" />
                          </div>
                          <Box className="d-flex align-items-center flex-column gap-1">
                            <span
                              className="default-icon replace-icon"
                              // onClick={handleReplaceFile}
                            >
                              <RoundedArrow />
                            </span>
                            <span
                              className="default-icon delete-icon"
                              onClick={(e) => {
                                e.stopPropagation();
                                e.preventDefault();
                                setPreviewImg(null);
                                resetField("upload_id");
                                if (fileInputRefs.current["uploadId"]) {
                                  fileInputRefs.current["uploadId"].value = "";
                                }
                              }}
                            >
                              <TrashIcon />
                            </span>
                          </Box>
                        </Box>
                      ) : (
                        <>
                          <Box className="d-flex align-items-center justify-content-center mt-n4 w-100">
                            <FileUpload size={26} />
                            &nbsp;&nbsp;
                            <SpanStyled color="var(--text)" size="14px">
                              {t("upload_job_id")}
                            </SpanStyled>
                          </Box>
                        </>
                      )}
                    </FileUploaderStyled>
                  )}
                />
              </Col>
              <Col lg={4}>
                <ValidationController
                  name={"upload_job_id"}
                  validationConfig={{
                    required: false,
                  }}
                  errors={errors}
                  control={control}
                  renderer={({ field }) => (
                    <FileUploaderStyled
                      className="d-flex align-items-center justify-content-center w-100"
                      onClick={(e) => {
                        if (secondPreviewImg) {
                          e.stopPropagation();
                          e.preventDefault();
                        }
                      }}
                    >
                      <Form
                        as="input"
                        name="upload_job_id"
                        type="file"
                        accept="image/*"
                        ref={(el) =>
                          (fileInputRefs.current["uploadJobId"] = el)
                        }
                        onChange={(e) => {
                          handleFileChange(e);
                          field.onChange(e.target.files[0]);
                        }}
                        className="d-none"
                      />
                      {secondPreviewImg ? (
                        <Box
                          className="d-flex align-items-center justify-content-between w-100 mt-n4 preview-box"
                          onClick={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                          }}
                        >
                          <div className="job-upload-preview-img">
                            <LazyImage src={secondPreviewImg} className="" />
                          </div>
                          <Box className="d-flex align-items-center flex-column gap-1">
                            <span
                              className="default-icon replace-icon"
                              // onClick={handleReplaceFile}
                            >
                              <RoundedArrow />
                            </span>
                            <span
                              className="default-icon delete-icon"
                              onClick={(e) => {
                                e.stopPropagation();
                                e.preventDefault();
                                setSecondPreviewImg(null);
                                resetField("upload_id");
                                if (fileInputRefs.current["uploadJobId"]) {
                                  fileInputRefs.current["uploadJobId"].value =
                                    "";
                                }
                              }}
                            >
                              <TrashIcon />
                            </span>
                          </Box>
                        </Box>
                      ) : (
                        <>
                          <Box className="d-flex align-items-center justify-content-center mt-n4 w-100">
                            <FileUpload size={26} />
                            &nbsp;&nbsp;
                            <SpanStyled color="var(--text)" size="14px">
                              {t("upload_id")}
                            </SpanStyled>
                          </Box>
                        </>
                      )}
                    </FileUploaderStyled>
                  )}
                />
              </Col>
            </Box>
          </Col>
        </Box>
      </Box>
    </FormDataContainer>
  );
};

export default UserPersonalInfo;
